export const ShoppingBagAlt = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M4.14218 12H27.8578L26.1245 25.0001H5.87552L4.14218 12Z" stroke="currentColor" stroke-width="2"/>
<path d="M11 7C11 5.89543 11.8954 5 13 5H19C20.1046 5 21 5.89543 21 7V12H11V7Z" stroke="currentColor" stroke-width="2"/>
</svg>`;
